import { render, staticRenderFns } from "./tutor.vue?vue&type=template&id=5144547d"
import script from "./tutor.vue?vue&type=script&lang=ts"
export * from "./tutor.vue?vue&type=script&lang=ts"
import style0 from "./tutor.vue?vue&type=style&index=0&id=5144547d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports